import React from "react";
import "./richTextEditorStyle.css";

const DisplayContent = ({ richTextContent }) => {
  return (
    <div
      className="px-3 rounded display-content"
      style={{
        paddingLeft: 0,
      }}
      dangerouslySetInnerHTML={{ __html: richTextContent }}
    />
  );
};

export default DisplayContent;
